import React, { useContext, useEffect, useState } from 'react';
import appContext from '../../../../context/app/appContext';
import CreateASpoolContext from '../../../../context/createASpool/createASpoolContext';
import themeContext from '../../../../context/theme/themeContext';
import {
    Table,
    Pagination,
    TableRowContainer,
    EmptyDataRow,
} from '../../../../components/Table';
import RiskModelAccordion from './RiskModelAccordion';
import Loading from '../../../../components/Loading';
import useIsMounted from '../../../../hooks/useIsMounted';

//Created by mistake
const HIDDEN_RISK_MODELS = '0xbd3e1449b6d173a5d6d5b9b5e0e8ae0e0f66ad10';

const RiskModel: React.FC = () => {
    const { selectedRiskModel, setStepCompletedStatus } = useContext(CreateASpoolContext);
    const { isLoading, riskModels } = useContext(appContext);

    const { theme } = useContext(themeContext);

    const [selectedAccordion, setSelectedAccordion] = useState<number | null>(null);

    const [disabled, setDisabled] = useState(false);

    const isMounted = useIsMounted();

    useEffect(() => {
        if (selectedRiskModel) {
            setStepCompletedStatus(2, true);
            return;
        }

        setStepCompletedStatus(2, false);
    }, [selectedRiskModel, setStepCompletedStatus]);

    const toggle = (riskModel: number) => {
        if (disabled) return;

        setSelectedAccordion((prev) => (prev === riskModel ? null : riskModel));
        setDisabled(true);
    };

    useEffect(() => {
        const timeout = setTimeout(() => {
            isMounted() && setDisabled(false);
        }, 1000);

        return () => {
            clearTimeout(timeout);
        };
    }, [selectedAccordion, isMounted]);

    return (
        <div className={`risk-model ${theme}`}>
            <span>
                Select a Risk Model for your Spool from the available Risk Models.
            </span>
            <Table
                headers={['Name', 'Creator', 'Fee on Yield', 'Select one']}
                numOfColumns={4}
                dataLength={Object.keys(riskModels || {}).length || 0}
            >
                <TableRowContainer>
                    <Loading
                        isLoading={isLoading.riskModels}
                        text='Loading Risk Models...'
                    >
                        {riskModels ? (
                            Object.keys(riskModels).length ? (
                                Object.entries(riskModels).map(
                                    ([riskModelAddress, feeOnYield], index) => {
                                        if (riskModelAddress === HIDDEN_RISK_MODELS) {
                                            return null;
                                        }

                                        return (
                                            <RiskModelAccordion
                                                key={index}
                                                riskModel={{
                                                    feeOnYield,
                                                    address: riskModelAddress,
                                                }}
                                                collapsed={index === selectedAccordion}
                                                toggle={() => toggle(index)}
                                            />
                                        );
                                    }
                                )
                            ) : (
                                <EmptyDataRow text='No Risk Models found...' />
                            )
                        ) : (
                            <EmptyDataRow text='An unexpected error occurred while loading Risk Models...' />
                        )}
                    </Loading>
                </TableRowContainer>
                <Pagination rowPerPage={5} />
            </Table>
        </div>
    );
};

export default RiskModel;
